export const getStoredTheme = () => {
  const saved = localStorage.getItem('theme');
  if (saved === 'light' || saved === 'dark') return saved;
  return null;
};

export const getSystemTheme = () =>
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';

export const applyTheme = (theme) => {
  const isDark = theme === 'dark';
  document.documentElement.classList.toggle('dark', isDark);
  document.body.classList.toggle('dark', isDark);
  localStorage.setItem('theme', theme);
};

export const initTheme = () => {
  const stored = getStoredTheme();
  applyTheme(stored || getSystemTheme());
};

export const toggleTheme = () => {
  const next = (getStoredTheme() || getSystemTheme()) === 'dark' ? 'light' : 'dark';
  applyTheme(next);
  return next;
};
